import React, {useContext} from 'react';

import {useTranslation} from 'common/i18n/hooks';
import {Content, Header} from 'common/onboarding/immersive-onboarding/components';
import {SetupGuideContext} from 'common/onboarding/immersive-onboarding/types';

import {VerifyConnection} from './VerifyConnection';

export const Verify = () => {
  const {t} = useTranslation();
  const {modalManager} = useContext(SetupGuideContext);
  const {closeModal} = modalManager;

  return (
    <>
      <Header
        title={t(`onboarding.sidenav.verify-connection`)}
        step={t(`onboarding.header.step-three`)}
        showCloseBtn
        showInviteBanner
        onClose={() => {
          closeModal();
        }}
      />
      <Content>
        <VerifyConnection />
      </Content>
    </>
  );
};
